export default __webpack_public_path__ + "static/media/USD.1fe79c07.svg";